import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { isPlatformBrowser, DOCUMENT, isPlatformServer } from '@angular/common';
import { LinkService } from '../../_services/langhfre.service';
@Component({
  selector: 'app-gc-editor',
  templateUrl: './gc-editor.component.html',
  styleUrls: ['./gc-editor.component.scss']
})
export class GcEditorComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    // private logger: NGXLogger,
  ) {
  }


  ngOnInit() {
    this.titleService.setTitle("AI 文法與拼字檢查，一鍵搞定，免費使用！");
    this.metaTagService.updateTag({ name: 'description', content: "Trinka 是一款免費的線上 AI 文法寫作工具，專為學術寫作與研究論文校對設計，提供文法檢查與語句潤飾功能。" });
    this.metaTagService.updateTag({ property: 'og:title', content: "AI 文法與拼字檢查，一鍵搞定，免費使用！" });
    this.metaTagService.updateTag({ property: 'og:description', content: "Trinka 是一款免費的線上 AI 文法寫作工具，專為學術寫作與研究論文校對設計，提供文法檢查與語句潤飾功能。" });    
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/grammar-checker' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/grammar-checker' });
    this.metaTagService.updateTag({ name: 'language', content: 'zh-tw' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/corrector-gramatical' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/grammar-checker' });
  }

  grammarCheckerTestimonials = [
    {
      "author": "Hugo Alberto Rivera Rodriguez",
      "designation": "Assitant Professor, Universidad del Rosario, Colombia",
      "message": "Trinka has allowed me to improve the articles I have published. In addition to giving me suggestions for journals according to my research.",
      "photo": "clientPhotos/hugo.jpg"
    },
    {
      "author": "Raquel Rodrigues",
      "designation": "PhD student, Universidade Federal de Minas Gerais, Brazil",
      "message": "The platform has helped me a lot not only with grammar, but also with the cohesion and coherence of my texts. The plagiarism checking and reference checking features are really good.",
      "photo": "clientPhotos/raquel_rodrigues.jpg"
    },
    {
      "author": "Dr. Maryam Razmgir",
      "designation": "Associate Professor - Iran University of Medical Sciences Tehran, Iran",
      "message": "I used Trinka for writing and checking grammar in Iran. Trinka helped me improve the writing. It also helped me to find and correct grammatical errors faster. The use of Trinka was a good experience. ",
      "photo": "clientPhotos/maryam.png"
    }
  ]
}
